import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/astronaut_main.svg";
import saturnLogo from "../../Assets/saturn.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Sonal Pandey</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <div className="space-container">
                <img
                  src={homeLogo}
                  alt="home pic"
                  className="img-fluid floating-astronaut"
                  style={{ maxHeight: "500px" ,
                  maxWidth: "450px"
                  
                }}
                />
                <img
                  src={saturnLogo}
                  alt="saturn"
                  className="img-fluid floating-saturn"
                  style={{ maxHeight: "150px" ,
                  maxWidth: "150px"
                  
                }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
